import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
  >
    <path d="M76.806 71v13.95l.005.309c.052 1.623.52 2.848 1.405 3.674.94.879 2.238 1.318 3.891 1.318s2.955-.44 3.906-1.318c.95-.878 1.426-2.206 1.426-3.983V71h2.821v13.95l-.004.325c-.064 2.362-.833 4.176-2.305 5.441-1.54 1.323-3.493 1.984-5.86 1.984-2.366 0-4.314-.661-5.843-1.984-1.53-1.323-2.294-3.245-2.294-5.766V71h2.852zm-65.598 0 8.091 17.608L27.359 71h2.883v21.483H27.39V76.828l-7.192 15.655h-1.829l-7.223-15.655v15.655H8.325V71h2.883zm35.661 0v2.232h-8.556v7.316h7.626v2.201h-7.626v7.502h8.556v2.232H35.492V71h11.377zm7.699 0 11.346 17.05V71h2.821v21.483h-2.821l-11.346-17.05v17.05h-2.821V71h2.821zM93.82 49v9H5v-9h88.82zm0-19v9H5v-9h88.82zm0-19v9H5v-9h88.82z" fill="currentColor" />
  </svg>
))``;
